import { createAction, props } from '@ngrx/store';
import { Transaction } from '../../models/transaction.interface';
import { QueryParamsModel } from '../../../_base/crud';

export const toggleTransactionsLoading = createAction(
  '[Transaction] Toggle Transactions Loading',
  props<{ transactionsLoading: boolean }>(),
);
export const loadTransactions = createAction(
  '[Transaction] Load Transactions',
  props<{ query: QueryParamsModel }>(),
);

export const reloadTransactions = createAction('[Transaction] Reload Transactions');

export const loadTransactionsSuccess = createAction(
  '[Transaction] Load Transactions Success',
  props<{
    transactions: Transaction[];
    totalTransactions: number;
    totalFailedTransactions: number;
    successRate: number;
    totalThisMonth: number;
    totalThisWeek: number;
    totalToday: number;
    monthOverMonthChange: number;
  }>(),
);

export const loadTransactionsFailure = createAction('[Transaction] Load Transactions Failure');

export const resetTransactionHistoryState = createAction(
  '[Transaction] Reset Transaction History State',
  props<{ saveFilter: boolean; filter: { [key: string]: any } }>(),
);
